import React, { useState } from "react";
import AdminSidebar from "../../../components/gcadmin/adminsidebar/AdminSidebar";
import AdminTopbar  from "../../../components/gcadmin/admintopbar/AdminTopbar";
import "../../../assets/css/gcadmin/adminlayout/AdminLayout.css";

const AdminMasterLayout = ({ children, onLogout }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="gcAdmin-layout">

      {/* Sidebar — desktop collapse + mobile overlay */}
      <AdminSidebar
        onLogout={onLogout}
        onCollapsedChange={setCollapsed}
      />

      {/* Main area — shifts with sidebar on desktop */}
      <div className={`gcAdmin-layout__main ${collapsed ? "gcAdmin-layout__main--collapsed" : ""}`}>

        {/* Sticky topbar */}
        <AdminTopbar title="Admin Control Panel" />

        {/* Page content */}
        <div className="gcAdmin-layout__content">
          {children}
        </div>

      </div>
    </div>
  );
};

export default AdminMasterLayout;